import { DAEMON_URL } from "../config";

export type ProjectSummary = { id: string; name: string };

async function doFetch(url: string, init: RequestInit): Promise<Response> {
  let res: Response;
  try {
    res = await fetch(url, init);
  } catch (e) {
    throw new Error(`network error: ${(e as Error).message}`);
  }
  if (res.status === 401) throw new Error("unauthorized");
  if (!res.ok) throw new Error(`http ${res.status}`);
  return res;
}

export async function listProjects(): Promise<ProjectSummary[]> {
  const url = `${DAEMON_URL}/projects`;
  const res = await doFetch(url, {
    method: "GET",
    headers: { "Accept": "application/json" },
    credentials: "include",
  });
  const body = (await res.json()) as { projects: ProjectSummary[] };
  return body.projects;
}
